//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/StructureDesign.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[[],"GetStructureDesignNavigatorRoot",{R_:{navRoot:"StructureDesign.StructureDesignNavigatorRoot"}},0,0],[["memberBody","numCorners","corners"],"AskCornerObjects",{},1,0],[["corner","numMembers","members"],"AskMembers",{},1,0]],[["ContextMenu","StructureDesign.ContextMenu",0]]];
SPLM.StructureDesign.StructureDesignSession = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.StructureDesign.StructureDesignSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;